export default __webpack_public_path__ + "static/media/10.6393d476.jpg";